/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_MoveInputs */

const en_common_move = /** @type {(inputs: Common_MoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move`)
};

const es_common_move = /** @type {(inputs: Common_MoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover`)
};

/**
* | output |
* | --- |
* | "Move" |
*
* @param {Common_MoveInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_move = /** @type {((inputs?: Common_MoveInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_MoveInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_move(inputs)
	return en_common_move(inputs)
});